const config = {
  tenantId: "fcb2b37b-5da0-466b-9b83-0014b67a7c78",
  clientId: "a569cae0-6d60-4bf1-9c41-fee8206e0aa6",
  redirectUri: `${window.location.origin}/ui/`,
  redirectUriLogin: `${window.location.origin}/ui/`,
  authority: "https://login.microsoftonline.com",
  scope: "openid profile https://bayer.com/a569cae0-6d60-4bf1-9c41-fee8206e0aa6/.default",
};
export default config;
